import Header from '../../components/Header/Header.js';
import TipDialog from '../../components/dialog/tipDialog.js';
import '../../assets/style/home.scss';
import ServiceList from './ServiceList';
import bannerItem from '../../assets/images/banner-item.png';
import chooseUsImg1 from '../../assets/images/choose-us-img1.png';
import chooseUsImg2 from '../../assets/images/choose-us-img2.png';
import chooseUsImg3 from '../../assets/images/choose-us-img3.png';
import chooseUsImg4 from '../../assets/images/choose-us-img4.png';
import chooseUsIcon1 from '../../assets/images/icon-dz.svg'
import chooseUsIcon2 from '../../assets/images/icon-zyk.svg'
import chooseUsIcon3 from '../../assets/images/icon-hz.svg'
import chooseUsIcon4 from '../../assets/images/icon-aq.svg'

import logo2 from '../../assets/images/icon_logo.png';
import qrcode from '../../assets/images/qrcode.png';
import systemInfoImg1 from '../../assets/images/system-info-item-1.png';
import systemInfoImg2 from '../../assets/images/system-info-item-2.png';
import systemInfoImg3 from '../../assets/images/system-info-item-3.png';
import systemInfoImg4 from '../../assets/images/system-info-item-4.png';
import footerimg from '../../assets//images/XUEQIANLIANMENG.png';
import iconPhone from '../../assets/images/icon-phone.svg';
import iconEmail from '../../assets/images/icon-email.svg';
import ShaderGradientComponent from './ShaderGradientComponent';
import React, {useEffect, useState, useRef} from 'react';


const HomeNew = () => {
    // 状态管理
    const [isOpen, setIsOpen] = useState(1); // 控制网站链接部分的展开/折叠状态
    const [platformRotateX, setPlatformRotateX] = useState(0); // 平台信息区域的X轴旋转角度
    const [systemInfoRotateZ, setSystemInfoRotateZ] = useState([-20, 20, -20, 20]); // 系统信息区域的Z轴旋转角度(四个区块)

    // 引用DOM元素
    const platformInfoRef = useRef(null);
    const systemInfoRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
    const startUseRef = useRef(null);
    const servicesWrap = useRef(null)
    let serviceRef = React.useRef()


    // 处理滚动事件
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const servicesWrapScrollT = servicesWrap.current.offsetTop

            handlePlatformScroll(scrollTop);
            handleSystemInfoScroll(scrollTop);
            serviceRef.current.onServiceListScroll(scrollTop, servicesWrapScrollT)
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // 初始触发一次

        return () => {
            window.removeEventListener('scroll', handleScroll)

        };
    }, []);

    /**
     * 处理平台信息区域的滚动效果
     * @param {number} scrollTop 当前滚动位置
     */
    const handlePlatformScroll = (scrollTop) => {
        if (!platformInfoRef.current) return;

        const rect = platformInfoRef.current.getBoundingClientRect();
        const platformInfoDistanceToTop = rect.top + scrollTop - 300;

        // 停留在视口或者向上滚动则不会产生动画效果
        const isElementCompletelyInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (isElementCompletelyInViewport) {
            platformInfoRef.current.style.transition = 'transform 0.3s ease'
            setPlatformRotateX(0);
            return;
        } else {
            platformInfoRef.current.style.transition = 'none'
        }
        if (scrollTop < platformInfoDistanceToTop) {
            const angle = Math.min(20 - (scrollTop / platformInfoDistanceToTop) * 20, 20);
            setPlatformRotateX(angle);
        }
    };


    /**
     * 处理系统信息区域的滚动效果
     * @param {number} scrollTop 当前滚动位置
     */
    const handleSystemInfoScroll = (scrollTop) => {
        const innerHeight = window.innerHeight + window.innerHeight / 2;
        const newRotations = [...systemInfoRotateZ];

        // 处理奇数区块(1和3)
        [0, 2].forEach((index) => {
            const ref = systemInfoRefs[index];
            if (!ref.current) return;

            const rect = ref.current.getBoundingClientRect();
            const distanceToTop = rect.top + scrollTop;
            const alreadyScrolled = innerHeight - rect.top;
            if (
                scrollTop > distanceToTop - innerHeight &&
                distanceToTop > -10
            ) {
                const startNum = (alreadyScrolled / window.innerHeight) * 20 - 20 > 0
                    ? 0
                    : (alreadyScrolled / window.innerHeight) * 20 - 20;
                const angle = Math.min(startNum, 20);

                // 设置奇数区块为正角度，偶数区块为负角度
                newRotations[index] = angle;
                newRotations[index + 1] = -angle;
            }
        });
        setSystemInfoRotateZ(newRotations);
    };


    // 渲染动画按钮组件
    const renderAnimatedButton = (text) => (
        <div className="animation-itemwrap" onClick={() => {
            handleBtnClick(text)
        }}>
            <div className="animation-itemparent">
                <div>
                    <div className="animation-item">{text}</div>
                    <div className="animation-item current">{text}</div>
                </div>
            </div>
        </div>
    );

    const handleBtnClick = (text) => {
        let title = '', topText = '扫码关注', bottomText = '', qrCodeDistance = '';
        switch (text) {
            case '开始试用':
                title = '小程序'
                topText = '扫码进入'
                qrCodeDistance = require('../../assets/images/qrcode/miniprogram.jpg')
                bottomText = '畅享高效教学'
                break
            case '联系购买':
                title = '客服'
                topText = '扫码联系'
                qrCodeDistance = require('../../assets/images/qrcode/customerService.png')
                bottomText = '专业客服团队为您答疑解惑'
                break
            case '公众号':
                title = '公众号'
                qrCodeDistance = require('../../assets/images/qrcode/officialAccount.jpg')
                bottomText = '开启智慧教育新体验'
                break
            case '小红书':
                title = '小红书'
                qrCodeDistance = require('../../assets/images/qrcode/redbook.png')
                bottomText = '获取幼师专业教学秘籍'
                break
            case '抖音':
                title = '抖音'
                qrCodeDistance = require('../../assets/images/qrcode/tiktok.png')
                bottomText = '与您共探AI+学前教育的无限可能'
                break
        }
        setModalTitle(title)
        setTopText(topText)
        setBottomText(bottomText)
        setIsModalOpen(true)
        setQrCodeDistance(qrCodeDistance)
    }

    // 渲染图标标题块组件
    const renderIconTitleBlock = ({icon, title, desc, desc2, key, animate = true}) => (
        <div className="icon-title-block" key={key}>
            <div className={`icon iconfont ${icon}`}></div>
            <div className="title">{title}</div>
            <div className="desc">{desc}</div>
            {desc2 && <div className="desc">{desc2}</div>}
            {animate && (
                <>
                    <div className="animate-bg"></div>
                    <div className="animate-arrow"></div>
                </>
            )}
        </div>
    );

    // 首屏六个模块数据
    const platformInfo = [
        {icon: "icon-icon-all", title: "一站式", desc: "覆盖学前教育", desc2: "教学管理全场景"},
        {
            icon: "icon-icon-yey",
            title: "园所管理",
            desc: "通过流程简化与工具赋能",
            desc2: "释放管理层的决策精力"
        },
        {icon: "icon-icon-ls", title: "创新性", desc: "学前联萌", desc2: "AI平台"},
        {
            icon: "icon-icon-jyj",
            title: "教师培养",
            desc: "构建阶梯式人才梯队",
            desc2: "提升教师专业价值"
        },
        {
            icon: "icon-icon-ls",
            title: "专业性",
            desc: "专业的学前教育资源数据",
            desc2: "专家资源+专业知识库"
        },
        {
            icon: "icon-icon-gx",
            title: "园所品牌",
            desc: "通过成果可视化与资源共享",
            desc2: "打造差异化园所形象"
        }
    ]

    // 中间四个卡片
    const serviceInfoList = [
        {
            title: "园所信息中心",
            desc: "数据驱动园所精细化管理，全方位提升园所管理效能",
            img: systemInfoImg1
        },
        {
            title: "教师档案中心",
            desc: "精准描绘教师成长轨迹，支持园所高效选拔、优化人才",
            img: systemInfoImg2
        },
        {
            title: "园所教科研管理",
            desc: "AI园本课程模块、AI课题科研模块、AI评估模块",
            img: systemInfoImg3
        },
        {
            title: "教师好帮手",
            desc: "园所教研培训模块、教师专业成长模块、教师教学模块、AI家园共育模块",
            img: systemInfoImg4
        }
    ]

    // 选择我们模块四个数据
    const chooseUsData = [
        {
            icon: chooseUsIcon1,
            title: "产品定制化",
            desc: "教育局人工智能管理平台、学前教育师范生成长平台",
            img: chooseUsImg1
        },
        {
            icon: chooseUsIcon2,
            title: "专业资源库",
            desc: "整合全国30+部属/省属院校教授、省市教研员和名园长等200+权威专家资源，提供课程指导、课题合作等深度服务。",
            img: chooseUsImg2
        },
        {
            icon: chooseUsIcon3,
            title: "合作案例",
            desc: "中国联通广西分公司与学前联萌签署战略合作协议",
            desc2: "3月13日，中国联通广西分公司与壹而叁文化教育科技（深圳）有限公司宣布建立战略合作。",
            img: chooseUsImg3
        },
        {
            icon:chooseUsIcon4,
            title: "数据安全",
            desc: "数据加密&脱敏、数据备份、私有化部署及内网搭建",
            img: chooseUsImg4
        }
    ]


    // 弹窗相关
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('提示');
    const [topText, setTopText] = useState('扫码关注');
    const [bottomText, setBottomText] = useState('专业客服团队 为您答疑解惑');
    const [qrCodeDistance, setQrCodeDistance] = useState('');
    const renderTipDialogContent = () => {
        return <>
            <div>{topText}</div>
            <img src={qrCodeDistance} alt=""/>
            <div>{bottomText}</div>
        </>
    }

    return (
        <div className="homepage">
            <Header></Header>
            <ShaderGradientComponent></ShaderGradientComponent>

            {/* 弹窗 */}
            <TipDialog open={isModalOpen} title={modalTitle} onClose={() => {
                setIsModalOpen(false)
            }}>
                {renderTipDialogContent()}
            </TipDialog>

            {/* 蓝色背景区域 */}
            <div className="bluebg">

                {/* Banner区域 */}
                <div className="mainwrap banner-wrap">
                    <div className=" banner-item">
                        <div className="banner-left">
                            <div
                                className="title animate__fast animate__animated animate__slideInUp">学前联萌AI平台
                            </div>
                            <div
                                className="desc animate__animated animate__slideInUp">数智化赋能学前教育未来新生态
                            </div>
                        </div>
                        <div className="banner-right">
                            <img src={bannerItem} alt="Banner展示图"/>
                        </div>
                    </div>
                </div>

                {/* 平台信息区域
                
                */}
                <div
                    ref={platformInfoRef}
                    className="mainwrap platform-info-wrap"
                    style={{transform: `rotateX(${platformRotateX}deg)`}}
                >
                    {/* 左侧内容 */}
                    <div className="platform-info-left">
                        {renderIconTitleBlock({
                            icon: "icon-icon-ls",
                            title: "学前联萌 萌生无限可能",
                            desc: "致力于成为中国学前教育人工智能的引领者",
                            animate: false
                        })}
                        <div className="btn-wrap">
                            {renderAnimatedButton("开始试用")}
                            {renderAnimatedButton("联系购买")}
                        </div>
                    </div>

                    {/* 中间内容 */}
                    <div className="platform-info-mid">
                        {renderIconTitleBlock({
                            title: "学前联萌AI平台",
                            desc: "数智化赋能学前教育未来新生态",
                            animate: false
                        })}
                        <div className="imgwrap"></div>
                    </div>

                    {/* 右侧内容 */}
                    <div className="platform-info-right">
                        <div>
                            {platformInfo.map((item, index) => (
                                renderIconTitleBlock({...item, key: index})
                            ))}
                        </div>
                    </div>
                </div>

                {/* 系统信息区域 */}
                <div className="system-info-wrap">
                    <div className="mainwrap system-info-test">
                        <div className="title">幼儿园AI管理平台</div>
                        <div className="desc">
                            依托云计算、物联网技术，并深度融合人工智能（如Deepseek等先进模型和算法），实现幼儿园教学管理的全面数智化建设，
                            AI技术集成，覆盖幼儿园课题、课程、培训、教研等场景，提升园所教学管理效率，产出优质教科研成果，
                            塑造卓越名师，打造园所品牌特色，建成智慧校园。
                        </div>
                    </div>

                    <div className="mainwrap system-info-block">
                        {serviceInfoList.map((item, index) => (
                            <div
                                key={index}
                                ref={systemInfoRefs[index]}
                                className="system-info-item"
                                style={{transform: `rotateZ(${systemInfoRotateZ[index]}deg)`}}
                            >
                                {renderIconTitleBlock({
                                    title: item.title,
                                    desc: item.desc,
                                    animate: false
                                })}
                                <div className="imgwrap">
                                    <img src={item.img} alt={`系统信息图${index + 1}`}/>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 选择我们区域 */}
            <div className="choose-us-wrap">
                <div className="mainwrap">
                    <div className="main-title">选择我们</div>
                    <div className="main-desc">信赖之选，共赢未来</div>

                    <div className="choose-us-list">
                        {chooseUsData.map((item, index) => (
                            <div
                                key={index}
                                className="choose-us-item"
                                id={`card_` + index}
                            >
                                <div className='card_content'>
                                    <div className="icon-title-block">
                                        <div>
                                            <div className="icon iconfont">
                                                <img src={item.icon} />
                                            </div>
                                            <div className="title">{item.title}</div>
                                            <div className="desc">{item.desc}</div>
                                            {item.desc2 && <div className="desc">{item.desc2}</div>}
                                        </div>
                                        <div className="index"><span>{`0${index + 1}`}</span> ——</div>
                                    </div>
                                    <div className="imagewrap">
                                        <img src={item.img} alt={`选择我们图${index + 1}`}/>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 白色背景区域 */}
            <div className="bgwhite">
                {/* 服务区域 */}
                <div className="services-wrap" ref={servicesWrap}>
                    <div className="services-left">
                        {renderIconTitleBlock({
                            icon: "icon-icon-ls",
                            title: "萌生无限可能",
                            animate: false
                        })}
                    </div>
                    <div className="services-list">
                        <ServiceList onRef={serviceRef}/>
                        <div className="serviceplaceholder"></div>
                    </div>
                </div>

                {/* 开始使用区域 */}
                <div className="start-use-wrap">
                    <div className="title">准备好开始探索学前联萌AI平台了吗</div>
                    <div className="btn-wrap">
                        {renderAnimatedButton("开始试用")}
                        {renderAnimatedButton("联系购买")}
                    </div>
                </div>
            </div>

            {/* 页脚区域 */}
            <div className="bgwhite">
                <div className="footer">
                    <div>
                        <div className="contact-us-wrap">
                            <div className="logo">
                                <img src={logo2} alt="公司Logo"/>
                                <div>公司简介：以"“技术赋能教育”为初心，引领教育局、幼儿园、高校迈向学前教育数智新未来。</div>
                            </div>

                            <div className="contact-us">
                                <div className="contact-us-detail">
                                    <div className="qrcode">
                                        <img src={qrcode} alt="二维码"/>
                                        <div>联系我们</div>
                                    </div>

                                    <div className="contact">
                                        <div>
                                            <img src={iconPhone} alt="电话图标"/>
                                            <div>
                                                <div>咨询热线</div>
                                                <div>0755-29414228</div>
                                            </div>
                                        </div>

                                        <div>
                                            <img src={iconEmail} alt="邮箱图标"/>
                                            <div>
                                                <div>客服邮箱</div>
                                                <div>Onetomore.edu@123xqlm.com</div>
                                            </div>
                                        </div>

                                        <div>公司地址：深圳市龙华区民治街道民新社区深国际华南数字谷A栋14B</div>
                                    </div>
                                </div>

                                <div className="copyright">
                                    ICP备案 粤ICP备2023095923号-1 Copyright © 2018-2025 壹而叁文化教育科技（深圳）有限公司
                                </div>
                            </div>
                        </div>

                        {/* 网站链接区域 */}
                        <div className="website-links">
                            {[
                                {
                                    title: "定制化产品",
                                    items: [{
                                        title: '教育局解决方案',
                                        url: 'https://mp.weixin.qq.com/s/n3ogVPRYLDG8z00XdWCywg'
                                    }, {
                                        title: '高校解决方案',
                                        url: 'https://mp.weixin.qq.com/s/NzyLu43yCG7xxf-deJxPzA'
                                    }]
                                },
                                {
                                    title: "联系方式",
                                    items: [{
                                        title: "关于我们",
                                        url: "https://mp.weixin.qq.com/s/Gu8cgZYGIZClXSoxwrg58w"
                                    }]
                                },
                                {
                                    title: "关注",
                                    items: [{
                                        title: "公众号",
                                        url: "javascript:void(0)"
                                    }, {
                                        title: "小红书",
                                        url: "javascript:void(0)"
                                    }, {
                                        title: "抖音",
                                        url: "javascript:void(0)"
                                    }]
                                }
                            ].map((section, index) => (
                                <div key={index} className={`links-list ${isOpen === index + 1 ? 'open' : 'close'}`}>
                                    <div className="title" onClick={() => setIsOpen(index + 1)}>
                                        {section.title}
                                        <div className="icon iconfont icon-icon-arrow"></div>
                                    </div>
                                    <ul>
                                        {section.title !== '关注' ?
                                            section.items.map((item, i) => (
                                                <li key={i}><a href={item.url} target="blank">{item.title}</a></li>
                                            )) : section.items.map((item, i) => (
                                                <li key={i}><a href={void (0)} onClick={() => {
                                                    handleBtnClick(item.title)
                                                }}>{item.title}</a></li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                    <img src={footerimg} className='footerimg'/>
                </div>
            </div>
        </div>
    );
};

export default HomeNew;